import { createSelector } from 'reselect';
import { get } from 'lodash';

export const comicsSelector = createSelector(
	state => state.comics,
	state => state.artists,
	(comics, artists) => {
		var comicsNew = {};
		for (var series in comics) {
			series = comics[series];
			var s = {};
			s.title = series.title;
			var artist = get(artists, series.artist);
			if (artist){
				s.artist = get(artist, 'name');
				s.artistSite = get(artist, 'artistSite');
				s.maxWidth = series.maxWidth;
				s.archiveThumbnail = series.archiveThumbnail;
				s.reverseOrder = series.reverse;
				s.isDrawable = series.isDrawable;
				s.comics = [];
				for (var comic in series.comics){
					var c;
					if (series.comics[comic].mobile.url){
						c = {
							'desktop': series.comics[comic].desktop.url,
							'mobile': series.comics[comic].mobile.url
						}
					}
					else {
						c = series.comics[comic].desktop.url;
					}
					s.comics.push(c);
				}
				comicsNew[series.id] = s;
			}
		}
		return comicsNew;
	}
);

export const seriesSelector = createSelector(
	state => state.comics,
	(state, props) => props.match.params.slug,
	(comics, slug) => comics[slug]
)



// WEBPACK FOOTER //
// ./src/client/selectors/comicsSelector.js